<template>
  <div>
    <div class="vx-row">
      <div class="vx-col w-full">
        <ul class="heading-ul mb-3">
          <li class="flex items-center">
            <router-link to="/inventory/vendor-management" class="mt-2 mr-2">
              <feather-icon icon="ArrowLeftIcon" svgClasses="text-dark" />
            </router-link>
            <h3>{{ $t("setup.label.ViewVendor") }}</h3>
          </li>
        </ul>
      </div>
      <div class="vx-col w-full">
        <vx-card title no-shadow card-border>
          <div class="vx-row">
            <div class="vx-col w-full md:w-full lg:w-full">
              <ul class="horizontal-sm-btn flex mb-2 float-right">
                <li>
                  <div
                    class="p-1 cursor-pointer flex items-center text-lg font-medium w-full"
                  >
                    <vs-button
                      color="primary"
                      icon-pack="feather"
                      icon="icon-edit-2"
                      class="truncate"
                      @click="editData(id)"
                      size="small"
                      >{{ $t("setup.label.Edit") }}</vs-button
                    >
                    <vs-button
                      color="danger"
                      icon-pack="feather"
                      icon="icon-x"
                      class="truncate"
                      size="small"
                      @click="deleteUserDataPopup = true"
                      >{{ $t("setup.label.Delete") }}</vs-button
                    >
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <div class="block overflow-x-auto">
            <table class="table w-full table-bordered table-striped">
              <tr>
                <td>
                  <b>{{ $t("setup.label.VendorCode") }}</b>
                </td>
                <td>{{ vendorData.vendorCode }}</td>
              </tr>
              <tr>
                <td>
                  <b>{{ $t("setup.label.VendorName") }}</b>
                </td>
                <td>{{ vendorData.vendorName }}</td>
              </tr>
              <tr>
                <td>
                  <b>{{ $t("setup.label.Email") }}</b>
                </td>
                <td>{{ vendorData.vendorEmailId }}</td>
              </tr>
              <tr>
                <td>
                  <b>{{ $t("setup.label.ContactName") }}</b>
                </td>
                <td>{{ vendorData.contactName }}</td>
              </tr>
              <tr>
                <td>
                  <b>{{ $t("setup.label.Mobile") }}</b>
                </td>
                <td>{{ vendorData.vendormobileNo }}</td>
              </tr>
              <tr>
                <td>
                  <b>{{ $t("setup.label.Landline") }}</b>
                </td>
                <td>{{ vendorData.vendorLandlineNo }}</td>
              </tr>
              <tr>
                <td>
                  <b>{{ $t("setup.label.Address") }}</b>
                </td>
                <td>{{ vendorData.vendorAddress }}</td>
              </tr>
              <tr>
                <td>
                  <b>{{ $t("setup.label.Currency") }}</b>
                </td>
                <td>{{ vendorData.vendorCurrency }}</td>
              </tr>
              <tr>
                <td>
                  <b>{{ $t("setup.label.Country") }}</b>
                </td>
                <td>{{ vendorData.vendorCountryName }}</td>
              </tr>
            </table>
          </div>
        </vx-card>
      </div>
    </div>
    <delete-popup
      :deletePopup="deleteUserDataPopup"
      title="Vendor"
      @deletePressed="deleteVendor(delId)"
      @cancelPressed="deleteUserDataPopup = false"
    >
    </delete-popup>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      deleteUserDataPopup: false,
    };
  },

  computed: {
    ...mapState({
      vendorData: (state) => state.vendorManagement.vendor,
    }),
  },
  methods: {
    async getVendorData() {
      try {
        await this.$store.dispatch(
          "vendorManagement/fetchVendorByIdAction",
          this.id
        );
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async deleteVendor() {
      try {
        await this.$store.dispatch("inventory/deleteVendorAction", this.id);
        this.deleteUserDataPopup = false;
        await this.$swal({
          title: "Success",
          icon: "success",
          text: "Vendor Deleted Successfully!",
          type: "success",
        });
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
      this.$router.push(`/inventory/vendor-management`);
    },
    editData(id) {
      this.$router.push({ name: "Edit Vendor Management", params: { id: id } });
    },
  },
  filters: {},
  created() {
    this.id = this.$route.params.id;
    this.getVendorData();
  },
};
</script>
<style scoped>
.table {
  width: 100%;
  max-width: 100%;
  margin-bottom: 20px;
  background-color: #fff;
  border: solid 1px #f0f0f0;
}

.table td {
  vertical-align: middle;
  border-top: none;
  padding: 10px 7px;
  font-size: 14px;
  color: #646a71;
  border-bottom: 1px solid #dfe3e7;
  transition: all 0.2s ease;
  overflow: hidden;
  word-break: break-all;
}
</style>
